import "./Home.scss";

import { motion } from "framer-motion";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import React, { MutableRefObject, useRef } from "react";

import BAM_DIGITAL from "../Assets/BAM Logo Frosty Tight Cropped.png";
import {
  Advertising,
  Automations,
  BusinessFinance,
  DataCommunications,
  Design,
  GetAllLogosShuffled,
  GetLogosShuffled,
  WebsitesLeads
} from "../Assets/Logos";
import HoverGrid from "../Obelisk/Components/Animations/HoverGrid";
import { ScrollSuggestion } from "../Obelisk/Components/Animations/ScrollSuggestion";
import { SlideList } from "../Obelisk/Components/Animations/SlideList";
import Text from "../Obelisk/Components/Text/Text";
import Typeform from "../Obelisk/Components/Typeform";
import { ContentPadding } from "../Obelisk/Structure/Padding";
import PageContainer from "../Obelisk/Structure/PageContainer";
import Section from "../Obelisk/Structure/Section";
import Ingram from "./Home/Ingram";

const Home: React.FC = () => {
  const scrollRef = useRef(null);
  return (
    <PageContainer
      seo={{
        title: "Home - BAM Digital",
        description: "Welcome to the new home of BAM Digital!",
        image: BAM_DIGITAL,
        canonical: "https://bamdigital.io/"
      }}
      bottomNav
      ref={scrollRef}
      className="home"
    >
      <div className="home-logos">
        <SlideList
          images={GetAllLogosShuffled()}
          deltaY={175}
          ySteps={6}
          delay={3000}
        />
        <Section center className="home-hero-titles">
          <Text h4 noPadding className="home-heroBuild">
            We Can Rebuild It
          </Text>
          <Text h2 className="home-hero-h2 ">
            We Have The Technology
          </Text>
        </Section>
        <div className="home-tagline">
          <SlideList
            images={GetLogosShuffled()}
            deltaY={-175}
            ySteps={6}
            showTaglines
            enlarge
          />
        </div>
      </div>

      <ScrollSuggestion />

      <Section extraPadding className="home-skill">
        <ContentPadding>
          <div className="home-skillTitles">
            <Text h2 noPadding>
              What We Do
            </Text>
            <Text p noPadding opacity={0.5} className="home-pLarge">
              BAM Digital is everything internet, including:
            </Text>
          </div>
          <div className="home-skillCategories">
            <div className="home-skillCategory">
              <Text h5 noPadding>
                What People See
              </Text>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Websites & Lead Magnets
                </Text>
                <HoverGrid images={WebsitesLeads} />
              </div>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Advertising
                </Text>
                <HoverGrid images={Advertising} />
              </div>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Design
                </Text>
                <HoverGrid images={Design} />
              </div>
            </div>
            <div className="home-skillCategory">
              <Text h5 noPadding>
                What Connects It
              </Text>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Automations & Integrations
                </Text>
                <HoverGrid images={Automations} />
              </div>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Communications
                </Text>
                <HoverGrid images={DataCommunications} />
              </div>
              <div className="home-skillSubcategory">
                <Text p opacity={1} noPadding className="home-skillSubtext">
                  Business & Finance
                </Text>
                <HoverGrid images={BusinessFinance} />
              </div>
            </div>
          </div>
          <div className="home-build">
            <Text h5 noPadding className="home-buildTitle">
              What We Build With It
            </Text>
            <Text p noPadding opacity={0.5} className="home-buildP">
              We assemble these parts into vast digital infrastructure to solve
              complex use-cases for organizations. Check out our featured
              example ↓
            </Text>
          </div>
        </ContentPadding>
      </Section>

      <Ingram ref={scrollRef} />

      <ContentPadding className="home-skillCategory home-get">
        <Text h2>What You Get</Text>
        <div className="home-skillSubcategory home-skillGetCategory">
          <Text h5 noPadding opacity={0.85}>
            Unlimited Potential
          </Text>
          <Text p opacity={0.5} className="home-skillStatement home-pMedium">
            We can build just about anything online, customized exactly as your
            business needs it.
          </Text>
        </div>
        <div className="home-skillSubcategory home-skillGetCategory">
          <Text h5 noPadding opacity={0.85}>
            A Comprehensive Agency
          </Text>
          <Text p opacity={0.5} className="home-skillStatement home-pMedium">
            We typically meet clients' full digital needs with our breadth of
            software & design experience.
            <br />
            <br />
            We've got this covered; no more playing project manager.
          </Text>
        </div>
      </ContentPadding>
      <Typeform />
    </PageContainer>
  );
};

export default Home;
